import { c as classnames } from './index-2586sEvh.js';
import React, { useContext } from 'react';
import Link from './components/Link/index.js';
import { CoreContext } from './context/index.js';
import { dataLabelFormat } from './utils/userClickHandler.js';

const MenuItem = ({ item, onClick, dataParentName }) => {
    var _a;
    const { data: { locale, siteConfig: { header: { subMenuImages = false, subMenuImageSize = null } = {} }, }, } = useContext(CoreContext);
    const title = item.localized_menu_item_title || item.original_title;
    const imageUrl = item.icon && subMenuImages
        ? `${process.env.NEXT_PUBLIC_GRAPHQL_API_URL.replace('/graphql', '')}/media/${item.icon}`
        : null;
    return (React.createElement("li", { className: classnames(item.children.length > 0 && 'has-children', item.item_class) },
        item.url !== 'null' && item.url !== null && (React.createElement(Link, { href: `/${locale}${item.url}`, className: classnames('sub-link', { 'has-image': imageUrl }), onClick: onClick, noUnderline: true, "data-event-name": "menu_interact", "data-menu-label": `${dataParentName}_${dataLabelFormat(title)}` },
            imageUrl && (React.createElement("img", { src: imageUrl, alt: title, loading: "lazy", ...((subMenuImageSize === null || subMenuImageSize === void 0 ? void 0 : subMenuImageSize.width) && { width: subMenuImageSize === null || subMenuImageSize === void 0 ? void 0 : subMenuImageSize.width }), ...((subMenuImageSize === null || subMenuImageSize === void 0 ? void 0 : subMenuImageSize.height) && { height: subMenuImageSize === null || subMenuImageSize === void 0 ? void 0 : subMenuImageSize.height }) })),
            imageUrl ? React.createElement("span", null, title) : title)),
        (item.url === 'null' || item.url === null) && React.createElement("span", { className: "third-label" }, title), (_a = item.children) === null || _a === void 0 ? void 0 :
        _a.map((childItem, index) => {
            const childTitle = childItem.localized_menu_item_title || childItem.original_title;
            const dataLabel = `${dataParentName}_${dataLabelFormat(childTitle)}`;
            return (React.createElement(Link
            // eslint-disable-next-line react/no-array-index-key
            , { 
                // eslint-disable-next-line react/no-array-index-key
                key: `${childItem.url}_${index}`, href: `/${locale}${childItem.url}`, className: `third-link ${childItem.item_class}`, noUnderline: true, onClick: onClick, "data-event-name": "menu_interact", "data-menu-label": dataLabel },
                React.createElement("span", null, childTitle)));
        })));
};

export { MenuItem as M };
//# sourceMappingURL=MenuItem-p_VGbV0y.js.map
